import React from "react";

const WagonTypeIcon = ({ color = "#6D7885", ...rest }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="1.6"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
    {...rest}
  >
    <rect x="3" y="5" width="18" height="11" rx="1.5" />
    <path d="M7 5v11M12 5v11M17 5v11M1 14h2m18 0h2M2 22h20" />
    <circle cx="7" cy="18.5" r="2.5" />
    <circle cx="17" cy="18.5" r="2.5" />
  </svg>
);

export default WagonTypeIcon;
